import { fadeInAnimationRule } from '@repo/ui/animations';
import styled, { css } from 'styled-components';

const enableFadeIn = css`
  animation: ${fadeInAnimationRule} 0.3s;
`;

export const FadeIn = styled.div<{ enabled?: boolean }>`
  ${({ enabled }) => enabled && enableFadeIn}
`;
